import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { DOCUMENT } from "@angular/common";

export interface PLSComponentResponse {
  htmlCode: string;
}

// We want this to be available anywhere as a singleton (no need to actively declare in child components)
@Injectable({
  providedIn: "root"
})
export class PLSComponentService {
  savedSelection: Range | null;
  selectedText: string;
  plsComponents: any[] = [
    { label: "Accordion", value: "accordion" },
    { label: "Tabs", value: "tabs" },
    { label: "Flip Card", value: "flipcard" }
  ];
  plsForeColors: any[] = [
    {
      name: "white text",
      class: "color-white"
    },
    {
      name: "black text",
      class: "color-black"
    },
    {
      name: "gray text",
      class: "color-gray"
    },
    {
      name: "light gray text",
      class: "color-gray-light"
    },
    {
      name: "dark gray text",
      class: "color-gray-dark"
    },
    {
      name: "red text",
      class: "color-red"
    },
    {
      name: "light red text",
      class: "color-red-light"
    },
    {
      name: "dark red text",
      class: "color-red-dark"
    },
    {
      name: "orange text",
      class: "color-orange"
    },
    {
      name: "light gold text",
      class: "color-gold-light"
    },
    {
      name: "gold text",
      class: "color-gold"
    },
    {
      name: "dark gold text",
      class: "color-gold-dark"
    },
    {
      name: "yellow text",
      class: "color-yellow"
    },
    {
      name: "blue text",
      class: "color-blue"
    },
    {
      name: "dark blue text",
      class: "color-blue-dark"
    },
    {
      name: "light blue text",
      class: "color-blue-light"
    },
    {
      name: "green text",
      class: "color-green"
    },
    {
      name: "dark green text",
      class: "color-green-dark"
    },
    {
      name: "light green text",
      class: "color-green-light"
    },
    {
      name: "maroon text",
      class: "color-maroon"
    },
    {
      name: "dark maroon text",
      class: "color-maroon-dark"
    },
    {
      name: "light maroon text",
      class: "color-maroon-light"
    },
    {
      name: "purple text",
      class: "color-purple"
    },
    {
      name: "dark purple text",
      class: "color-purple-dark"
    },
    {
      name: "light purple text",
      class: "color-purple-light"
    }
  ];
  plsBackColors: any[] = [
    {
      name: "white background",
      class: "bg-color-white"
    },
    {
      name: "black background",
      class: "bg-color-black"
    },
    {
      name: "gray background",
      class: "bg-color-gray"
    },
    {
      name: "light gray background",
      class: "bg-color-gray-light"
    },
    {
      name: "dark gray background",
      class: "bg-color-gray-dark"
    },
    {
      name: "red background",
      class: "bg-color-red"
    },
    {
      name: "light red background",
      class: "bg-color-red-light"
    },
    {
      name: "dark red background",
      class: "bg-color-red-dark"
    },
    {
      name: "orange background",
      class: "bg-color-orange"
    },
    {
      name: "light gold background",
      class: "bg-color-gold-light"
    },
    {
      name: "gold background",
      class: "bg-color-gold"
    },
    {
      name: "dark gold background",
      class: "bg-color-gold-dark"
    },
    {
      name: "yellow background",
      class: "bg-color-yellow"
    },
    {
      name: "blue background",
      class: "bg-color-blue"
    },
    {
      name: "dark blue background",
      class: "bg-color-blue-dark"
    },
    {
      name: "light blue background",
      class: "bg-color-blue-light"
    },
    {
      name: "green background",
      class: "bg-color-green"
    },
    {
      name: "dark green background",
      class: "bg-color-green-dark"
    },
    {
      name: "light green background",
      class: "bg-color-green-light"
    },
    {
      name: "maroon background",
      class: "bg-color-maroon"
    },
    {
      name: "dark maroon background",
      class: "bg-color-maroon-dark"
    },
    {
      name: "light maroon background",
      class: "bg-color-maroon-light"
    },
    {
      name: "purple background",
      class: "bg-color-purple"
    },
    {
      name: "dark purple background",
      class: "bg-color-purple-dark"
    },
    {
      name: "light purple background",
      class: "bg-color-purple-light"
    }
  ];

  constructor(private http: HttpClient, @Inject(DOCUMENT) private doc: any) { }

  /**
   * Create raw HTML
   * @param html HTML string
   */
  insertHtml(html: string): void {
    const selObj = window.getSelection();
    console.log(document.activeElement);
    const isHTMLInserted = this.doc.execCommand("insertHTML", false, html);

    if (!isHTMLInserted) {
      throw new Error("Unable to perform the operation");
    }
  }

  getForeColors(): any[] {
    return this.plsForeColors;
  }
  getBackColors(): any[] {
    return this.plsBackColors;
  }
  getPLSComponentList(): any[] {
    return this.plsComponents;
  }

  insertPLSAccordion(): void {
    const numAccordions = $(".cha-accordion").length;
    const curAcc = numAccordions + 1;
    const html =
      `
<!--- PLS ACCORDION -->
<div id="plsAccordion` +
      curAcc +
      `"><div class="cha-accordion">
  <div class="accordion-section">
    <div class="accordion-section-title">Section 1</div>
    <div class="accordion-section-content open" style="display: none;">
      <p>[Type accordion section content here</p>
    </div>
  </div>
  <div class="accordion-section">
    <div class="accordion-section-title">Section 2</div>
    <div class="accordion-section-content">
      <p>[Type accordion section content here</p>
    </div>
  </div>
  <div class="accordion-section">
    <div class="accordion-section-title">Section 3</div>
    <div class="accordion-section-content">
      <p>[Type accordion section content here</p>
    </div>
  </div>
  <div class="accordion-section">
    <div class="accordion-section-title">Section 4</div>
    <div class="accordion-section-content">
      <p>[Type accordion section content here</p>
    </div>
  </div>
</div></div>
<!--- PLS ACCORDION -->`;
    this.insertHtml(html);
    const curEl = $(".angular-editor-textarea  #plsAccordion" + curAcc);
    // @ts-ignore
    initCoursePlayerComponents(curEl);
  }
}
